import React from 'react'
import './powerfull.scss';

const Powerfull = () => {
    return (
        <section className='main_Power' id='about'>

            <img src='\assets\elipses.png' className='imgleft' />
            <img src='\assets\elipsesright.png' className='imgleft1' />
            <div className='innner_power'>
                <div className='custom-container'>
                    <div className='nnermore'>
                        <img src='\assets\powerimg.png' className='img_power' />
                        <h2> <span>Crypto is powerful</span> — but painfully complex for users</h2>
                        <p>Your users shouldn’t need to understand what chain your dApp is built on, how to bridge assets between different networks, or which token version to use. They should simply be able to deposit what they already have and start using your app—and Aqua makes that possible.</p>
                    </div>

                </div>
            </div>

        </section>
    )
}

export default Powerfull
